import { Directive, AfterViewInit, OnChanges, Input, Output, EventEmitter, ElementRef, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ConfigurationService } from '../services/configuration.service';

declare var $: any;

@Directive({
  selector: '[appAppSelect2]'
})

export class AppSelect2Directive implements AfterViewInit, OnChanges {

  select2: any;

  @Input()
  dataUrl: string;

  @Input()
  placeholder: string;

  @Output()
  itemSelected = new EventEmitter<boolean>();

  constructor(
    private el: ElementRef,
    private control: NgControl,
    private configuration: ConfigurationService,
    ) { }

  ngAfterViewInit(): void {
    if (this.dataUrl) {
      this.initializeSelect2();
    }
  }

  initializeSelect2() {
    console.log('select2 ' + this.dataUrl);
    const fullUrl = this.configuration.apiUrl + this.dataUrl;
    this.select2 = $(this.el.nativeElement).select2({
      allowClear: true,
      placeholder: this.placeholder || 'Please select',
      ajax: {
        url: fullUrl,
        data(params) {
            const query = {
                search: params.term,
                page: params.page || 1,
            };

            return query;
        },
        processResults(data) {
            return {
                results: data.results,
                pagination: data.pagination
            };
        }
      }
    });

    this.select2.on('select2:select', (event: any) => {
      const selectedItem = event.params.data;
      this.control.control.setValue(selectedItem.id);
      this.itemSelected.emit(selectedItem);
    });

    this.select2.on('select2:open', (event: any) => {
      this.control.control.markAsTouched();
    });
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    const dataUrl = changes.dataUrl;

    // There are instances that at first dataUrl are not available.
    if (dataUrl.currentValue) {
      this.initializeSelect2();
    }
  }

  clear() {
    if (this.select2) {
      this.select2.val(null).trigger('change');
      this.control.control.setValue(null);
    }
  }
}
